"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const custom_cell_style_1 = __importDefault(require("../custom-cell.style"));
const customStatusCell = ({ dataIndex, dataItem, field, style }) => {
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 1, style: style, role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, id: `m_grid_cell_${field}_${dataIndex}` }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: custom_cell_style_1.default.statusStyle(dataItem.status) }, { children: dataItem.status })) })));
};
exports.default = customStatusCell;
